import { DEMO_INTENT, POST_AUTH_INTENT_KEY } from "../constants/demoContract";
import { persistPendingDemoAsDraft } from "../services/demoContractResumeService";

export async function navigateAfterAuth(navigate, locationState) {
  const intent = sessionStorage.getItem(POST_AUTH_INTENT_KEY);

  if (intent === DEMO_INTENT) {
    sessionStorage.removeItem(POST_AUTH_INTENT_KEY);
    const result = await persistPendingDemoAsDraft();

    if (result.success) {
      navigate(
        `/contract-generator?job_id=${encodeURIComponent(result.jobId)}`,
        {
          replace: true,
          state: { demoRestored: true },
        }
      );
      return;
    }
  }

  const fromPath = locationState?.from?.pathname;
  navigate(fromPath || "/contract-dashboard", { replace: true });
}
